import { roundToNearestHour } from "../roundHours/roundHours";

export const formatterHourTooltip = (
  hour: number,
  timelineStartDate: number,
  timezone: string
): string => {
  const startDate = roundToNearestHour(timelineStartDate).setZone(timezone);

  const initialHour = startDate.hour;

  const adjustedHour = (hour + initialHour) % 24;

  return adjustedHour + "h";
};
